import { render, staticRenderFns } from "./ccAvenueQR.vue?vue&type=template&id=2aecff10"
import script from "./ccAvenueQR.vue?vue&type=script&lang=js"
export * from "./ccAvenueQR.vue?vue&type=script&lang=js"
import style0 from "./ccAvenueQR.vue?vue&type=style&index=0&id=2aecff10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports